/**
 * Keeps the app frame on the part of the screen a phone browser shows. iOS Safari lays
 * its keyboard over the page and pans the page up to reveal the focused field, which
 * reads as the whole screen jumping; Chrome on Android resizes the layout instead
 * (`interactive-widget=resizes-content`), where this changes nothing. Sizing the frame to
 * the visual viewport and following its offset leaves the composer resting on the
 * keyboard with the header still in place. Inside the HeyDay News app the app lays the
 * view out above the keyboard itself.
 */
export function fitToVisualViewport(viewport: VisualViewport, root: HTMLElement): () => void {
  const fit = () => {
    root.style.setProperty("--visual-viewport-height", `${viewport.height}px`);
    root.style.setProperty("--visual-viewport-top", `${viewport.offsetTop}px`);
  };
  fit();
  viewport.addEventListener("resize", fit);
  viewport.addEventListener("scroll", fit);
  return () => {
    viewport.removeEventListener("resize", fit);
    viewport.removeEventListener("scroll", fit);
  };
}
